import { createWebHistory, createRouter } from 'vue-router'
import { DOCUMENT_TITLE_PREFIX } from '@/libs/constants'

import { getLangCookie, tokenCheck, getSiteId, getPrefixFromHost } from '@/libs/auth-helper'

import store from '../store'
import Member from '@/views/member/index.vue'
import warning from '@/views/warning.vue'
import betAll from '@/views/member/partner/betting/betAll.vue'
import dateBet from '@/views/member/partner/statistic/dateBet.vue'
import views from '@/views/index.vue'
import partner from '@/views/member/partner/index.vue'
import main from '@/views/member/partner/main.vue'
import partnerList from '@/views/member/partner/partnerList.vue'
import partnerListLevel from '@/views/member/partner/partnerListLevel.vue'
import partnerDetail from '@/views/member/partner/partnerDetail.vue'
import userList from '@/views/member/partner/userList.vue'
import userDetail from '@/views/member/partner/userDetail.vue'
import cashList from '@/views/member/partner/cashList.vue'
import cashListMy from '@/views/member/partner/cashListMy.vue'
import bettingList from '@/views/member/partner/bettingList.vue'
import bettingListSport from '@/views/member/partner/bettingListSport.vue'
import partnerList2 from '@/views/member/partner/partnerList2.vue'
import partnerRate from '@/views/member/partner/partnerRate.vue'
import pointList from '@/views/member/partner/point/pointList.vue'
import calculationList from '@/views/member/partner/calculationList.vue'
import calculationUserList from '@/views/member/partner/calculationUserList.vue'
import memberList from '@/views/member/partner/memberList.vue'
import onlineMemberList from '@/views/member/partner/onlineMemberList.vue'
import moneyMove from '@/views/member/partner/moneyMove.vue'
import subMemberList from '@/views/member/partner/subMemberList.vue'
import charge from '@/views/member/partner/cash/charge.vue'
import exchange from '@/views/member/partner/cash/exchange.vue'
import pointListU from '@/views/member/partner/point/pointListU.vue'
import pointUse from '@/views/member/partner/point/pointUse.vue'
import pointUseList from '@/views/member/partner/point/pointUseList.vue'
import subpartnerPointList from '@/views/member/partner/subpartnerPointList.vue'
import qna from '@/views/member/partner/board/qna.vue'
import qnaRead from '@/views/member/partner/board/qnaRead.vue'
import noticeList from '@/views/member/partner/board/noticeList.vue'
import noticeRead from '@/views/member/partner/board/noticeRead.vue'
import qnaWrite from '@/views/member/partner/board/qnaWrite.vue'
import msg from '@/views/member/partner/board/msg.vue'
import msgRead from '@/views/member/partner/board/msgRead.vue'
import info from '@/views/member/partner/info.vue'
import allUsers from '@/views/member/partner/statistic/allUsers.vue'
import allGames from '@/views/member/partner/statistic/allGames.vue'
import dateGames from '@/views/member/partner/statistic/dateGames.vue'
import list from '@/views/member/partner/users/list.vue'
import onlinelist from '@/views/member/partner/users/onlinelist.vue'
import bettingDetailList from '@/views/member/partner/betting/bettingDetailList_white'

const routes = [
  {
    name: 'warning',
    path: '/warning',
    component: warning,
    meta: { layout: 'empty', guestOnly: true }
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    name: 'partnerLogin',
    path: '/login',
    component: Member,
    meta: {
      layout: 'default',
      text: '파트너 페이지',
      gnb: false,
      guestOnly: true
    }
  },
  {
    path: '/',
    name: 'main',
    component: views,
    meta: {
      layout: 'empty',
      guestOnly: true
    },
    redirect: {
      name: 'partnerMain'
    },
    children: [
      {
        name: 'partner',
        path: '/main',
        component: partner,
        redirect: {
          name: 'partnerMain'
        },
        meta: {
          layout: 'default',
          text: '메인',
          gnb: false
        },
        children: [
          {
            name: 'partnerMain',
            path: '/partnerMain',
            component: main,
            meta: {
              layout: 'default',
              text: '파트너 메인',
              gnb: false
            }
          },
          {
            name: 'partnerList',
            path: '/partnerList',
            component: partnerList,
            meta: {
              layout: 'default',
              text: '파트너 리스트',
              gnb: false
            }
          },
          {
            name: 'partnerListLevelPTN_1',
            path: '/partnerListLevelPTN_1',
            component: partnerListLevel,
            meta: {
              layout: 'default',
              text: '파트너 리스트 레벨',
              gnb: false
            }
          },
          {
            name: 'partnerListLevelPTN_2',
            path: '/partnerListLevelPTN_2',
            component: partnerListLevel,
            meta: {
              layout: 'default',
              text: '파트너 리스트 레벨',
              gnb: false
            }
          },
          {
            name: 'partnerListLevelPTN_3',
            path: '/partnerListLevelPTN_3',
            component: partnerListLevel,
            meta: {
              layout: 'default',
              text: '파트너 리스트 레벨',
              gnb: false
            }
          },
          {
            name: 'partnerListLevelPTN_4',
            path: '/partnerListLevelPTN_4',
            component: partnerListLevel,
            meta: {
              layout: 'default',
              text: '파트너 리스트 레벨',
              gnb: false
            }
          },
          {
            name: 'partnerListLevelPTN_5',
            path: '/partnerListLevelPTN_5',
            component: partnerListLevel,
            meta: {
              layout: 'default',
              text: '파트너 리스트 레벨',
              gnb: false
            }
          },
          {
            name: 'partnerListLevelPTN_6',
            path: '/partnerListLevelPTN_6',
            component: partnerListLevel,
            meta: {
              layout: 'default',
              text: '파트너 리스트 레벨',
              gnb: false
            }
          },
          {
            name: 'partnerListLevelPTN_7',
            path: '/partnerListLevelPTN_7',
            component: partnerListLevel,
            meta: {
              layout: 'default',
              text: '파트너 리스트 레벨',
              gnb: false
            }
          },
          {
            name: 'partnerDetail',
            path: '/partnerDetail',
            component: partnerDetail,
            meta: {
              layout: 'default',
              text: '파트너 상세',
              gnb: false
            }
          },
          {
            name: 'partnerUserList',
            path: '/userList',
            component: userList,
            meta: {
              layout: 'default',
              text: '회원목록',
              gnb: false
            }
          },
          {
            name: 'userDetail',
            path: '/userDetail',
            component: userDetail,
            meta: {
              layout: 'default',
              text: '회원상세',
              gnb: false
            }
          },
          {
            name: 'partnerCashList',
            path: '/cashList',
            component: cashList,
            meta: {
              layout: 'default',
              text: '파트너 페이지',
              gnb: false
            }
          },
          {
            name: 'cashListMy',
            path: '/cashListMy',
            component: cashListMy,
            meta: {
              layout: 'default',
              text: '보유머니변동내역',
              gnb: false
            }
          },
          {
            name: 'partnerBettingList',
            path: '/bettingList',
            component: bettingList,
            meta: {
              layout: 'default',
              text: '파트너 페이지',
              gnb: false
            }
          },
          {
            name: 'partnerBettingListSport',
            path: '/bettingListSport',
            component: bettingListSport,
            meta: {
              layout: 'default',
              text: '파트너 페이지',
              gnb: false
            }
          },
          {
            name: 'partnerList2',
            path: '/partnerList2',
            component: partnerList2,
            meta: {
              layout: 'default',
              text: '파트너 페이지',
              gnb: false
            }
          },
          {
            name: 'partnerRate',
            path: '/partnerRate',
            component: partnerRate,
            meta: {
              layout: 'default',
              text: '파트너 페이지',
              gnb: false
            }
          },
          {
            name: 'pointList',
            path: '/pointList',
            component: pointList,
            meta: {
              layout: 'default',
              text: '포인트적립내역',
              gnb: false
            }
          },
          {
            name: 'partnerCalculationList',
            path: '/partnerCalculationList',
            component: calculationList,
            meta: {
              layout: 'default',
              text: '파트너 페이지',
              gnb: false
            }
          },
          {
            name: 'partnerCalculationUserList',
            path: '/partnerCalculationUserList',
            component: calculationUserList,
            meta: {
              layout: 'default',
              text: '파트너 페이지',
              gnb: false
            }
          },
          {
            name: 'partnerMemberList',
            path: '/partnerMemberList',
            component: memberList,
            meta: {
              layout: 'default',
              text: '파트너 페이지',
              gnb: false
            }
          },
          {
            name: 'onlineMemberList',
            path: '/onlineMemberList',
            component: onlineMemberList,
            meta: {
              layout: 'default',
              text: '파트너 페이지',
              gnb: false
            }
          },
          {
            name: 'partnerMoneyMoveList',
            path: '/partnerMoneyMoveList',
            component: moneyMove,
            meta: {
              layout: 'default',
              text: '파트너 페이지',
              gnb: false
            }
          },
          {
            name: 'subMemberList',
            path: '/subMemberList',
            component: subMemberList,
            meta: {
              layout: 'default',
              text: '파트너 페이지',
              gnb: false
            }
          },
          {
            name: 'charge',
            path: '/charge',
            component: charge,
            meta: {
              layout: 'default',
              text: '입금',
              gnb: false
            }
          },
          {
            name: 'exchange',
            path: '/exchange',
            component: exchange,
            meta: {
              layout: 'default',
              text: '출금',
              gnb: false
            }
          },
          {
            name: 'point',
            path: '/point',
            component: pointListU,
            meta: {
              layout: 'default',
              text: '포인트',
              gnb: false
            }
          },
          {
            name: 'pointuse',
            path: '/pointuse',
            component: pointUse,
            meta: {
              layout: 'default',
              text: '포인트',
              gnb: false
            }
          },
          {
            name: 'pointuselist',
            path: '/pointuselist',
            component: pointUseList,
            meta: {
              layout: 'default',
              text: '포인트',
              gnb: false
            }
          },
          {
            name: 'subpartnerPointList',
            path: '/subpartnerPointList',
            component: subpartnerPointList,
            meta: {
              layout: 'default',
              text: '하부파트너 포인트적립내역',
              gnb: false
            }
          },
          {
            name: 'qna',
            path: '/qna',
            component: qna,
            meta: {
              layout: 'default',
              text: '문의',
              gnb: false
            }
          },
          {
            name: 'qnaread',
            path: '/qnaread/:boardIdx',
            component: qnaRead,
            meta: {
              layout: 'default',
              text: '문의',
              gnb: false
            }
          },
          {
            name: 'noticeList',
            path: '/noticeList',
            component: noticeList,
            meta: {
              layout: 'default',
              text: '공지사항목록',
              gnb: false
            }
          },
          {
            name: 'noticeRead',
            path: '/noticeRead/:boardIdx',
            component: noticeRead,
            meta: {
              layout: 'default',
              text: '공지사항',
              gnb: false
            }
          },
          {
            name: 'qnaWrite',
            path: '/qnawrite',
            component: qnaWrite,
            meta: {
              layout: 'default',
              text: '문의작성',
              gnb: false
            }
          },
          {
            name: 'msg',
            path: '/msg',
            component: msg,
            meta: {
              layout: 'default',
              text: '메세지',
              gnb: false
            }
          },
          {
            name: 'msgread',
            path: '/msgread/:msgIdx',
            component: msgRead,
            meta: {
              layout: 'default',
              text: '메세지',
              gnb: false
            }
          },
          {
            name: 'infoEdit',
            path: '/infoEdit',
            component: info,
            meta: {
              layout: 'default',
              text: '회원정보수정',
              gnb: false
            }
          },
          {
            name: 'statAllUser',
            path: '/statisticAllUsers',
            component: allUsers,
            meta: {
              layout: 'default',
              text: '전체 사용자별 게임기록 통계',
              gnb: false
            }
          },
          {
            name: 'statAllGame',
            path: '/statisticAllGames',
            component: allGames,
            meta: {
              layout: 'default',
              text: '전체 게임별 게임기록 통계',
              gnb: false
            }
          },
          {
            name: 'statDateAgent',
            path: '/statisticDateAgent',
            component: () => import('@/views/member/partner/statistic/dateAgent.vue'),
            meta: {
              layout: 'default',
              text: '일자별 매장별 게임기록 통계',
              gnb: false
            }
          },
          {
            name: 'statDateUsers',
            path: '/statisticDateUsers',
            component: () => import('@/views/member/partner/statistic/dateUsers.vue'),
            meta: {
              layout: 'default',
              text: '일자별 사용자별 게임기록 통계',
              gnb: false
            }
          },
          {
            name: 'statDateGames',
            path: '/statisticDateGames',
            component: dateGames,
            meta: {
              layout: 'default',
              text: '일자별 게임별 게임기록 통계',
              gnb: false
            }
          },
          {
            name: 'statDateBet',
            path: '/statisticDateBet',
            component: dateBet,
            meta: {
              layout: 'default',
              text: '일자별 베팅현황',
              gnb: false
            }
          },
          {
            name: 'bettingslot',
            path: '/bettingslot',
            component: betAll,
            meta: {
              layout: 'default',
              text: '베팅현황(슬롯)',
              gnb: false
            }
          },
          {
            name: 'bettingcasino',
            path: '/bettingcasino',
            component: betAll,
            meta: {
              layout: 'default',
              text: '베팅현황(카지노)',
              gnb: false
            }
          },
          {
            name: 'bettingtotal',
            path: '/bettingtotal',
            component: betAll,
            meta: {
              layout: 'default',
              text: '베팅현황(전체)',
              gnb: false
            }
          },
          {
            name: 'bettingDetailListCasino',
            path: '/bettingDetailListCasino',
            component: bettingDetailList,
            meta: {
              layout: 'default',
              text: '베팅내역(카지노)',
              gnb: false
            }
          },
          {
            name: 'bettingDetailListSlot',
            path: '/bettingDetailListSlot',
            component: bettingDetailList,
            meta: {
              layout: 'default',
              text: '베팅내역(슬롯)',
              gnb: false
            }
          },
          {
            name: 'bettingDetailListSport',
            path: '/bettingDetailListSport',
            component: bettingDetailList,
            meta: {
              layout: 'default',
              text: '베팅내역(스포츠)',
              gnb: false
            }
          },
          {
            name: 'userlist',
            path: '/users/list',
            component: list,
            meta: {
              layout: 'default',
              text: '회원목록',
              gnb: false
            }
          },
          {
            name: 'onlinelist',
            path: '/userOnlinelist',
            component: onlinelist,
            meta: {
              layout: 'default',
              text: '접속회원목록',
              gnb: false
            }
          }
        ]
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: {
      name: 'dashboard'
    }
  }
]

const router = createRouter({
  history: createWebHistory(), // 2.x대를 설치하시면 작동을 안합니다.
  routes,
  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ top: 0, left: 0 })
      }, 0)
    })
  }
})

router.beforeEach(async (to, from, next) => {
  let title = DOCUMENT_TITLE_PREFIX

  const hostname = window.location.hostname
  if (hostname === 'drg-000.com') {
    title = '드래곤 파트너 페이지'
  }

  const prefix = getPrefixFromHost()
  const siteIdInfo = getSiteId(prefix)

  if (!siteIdInfo || !siteIdInfo.siteId) {
    return next('/login')
  }

  await store.dispatch('storeSiteIdInfo', siteIdInfo)

  if (to.name === 'warning') return next()

  const result = await tokenCheck()
  if (to.meta.guestOnly || result) {
    next()
  } else {
    const lang = getLangCookie()
    let msg = '로그인 이후 이용 가능합니다.'
    if (lang !== 'ko') {
      msg = 'Please Log-in'
    }
    alert(msg)
    return next('/login')
  }

  document.title = title
})

export default router
